module.exports = __webpack_public_path__ + "static/media/titan-roofing-ltd.49d050a2.png";